/**
 * <s-color-switcher> — recolors every product card in a grid at once.
 *
 * Clicking a color button calls showColor() on each <s-color-peek> card inside this element,
 * so all products switch to that shirt color. Cards without that color keep their current image.
 *
 * Required markup:
 *   button[data-color-choice="<color name>"][aria-pressed] — color buttons.
 *   s-color-peek                                          — product cards (see s-color-peek.js).
 */
class SColorSwitcher extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('click', this.#handleClick, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #handleClick = (event) => {
    const button = event.target.closest('button[data-color-choice]');
    if (!button || !this.contains(button)) return;
    const name = button.dataset.colorChoice;

    for (const choice of this.querySelectorAll('button[data-color-choice]')) {
      choice.setAttribute('aria-pressed', String(choice === button));
    }
    for (const card of this.querySelectorAll('s-color-peek')) {
      if (typeof card.showColor === 'function') card.showColor(name);
    }
  };
}

if (!customElements.get('s-color-switcher')) {
  customElements.define('s-color-switcher', SColorSwitcher);
}
